export const dateFormatter = (date) => {

    const dateObj = new Date(date);
    

    const day = dateObj.getDate();
    const month = dateObj.getMonth();
    const year = dateObj.getFullYear();

    return `${day}/${month+1}/${year}`;
}

export const dateFormatterShort = (date) => {
    const dateObj = new Date(date);
    

    const day = dateObj.getDate();
    const month = dateObj.getMonth();

    return `${day}/${month+1}`;
}

export const dateInputFormatter = () => {
    const today = new Date();
    const currentYear = today.getFullYear();
    let currentMonth = today.getMonth()+1;

    let day = today.getDate();

    if (currentMonth < 10) {
        currentMonth = `0${currentMonth}`
    }
    if (day < 10) {
        day = `0${day}`
    }
    const dateInputFormatted = `${currentYear}-${currentMonth}-${day}`

    return dateInputFormatted
}

export const dateInputFormatterByValue = (date) => {
    const today = new Date(date);
    const currentYear = today.getFullYear();
    let currentMonth = today.getMonth()+1;

    let day = today.getDate();

    if (currentMonth < 10) {
        currentMonth = `0${currentMonth}`
    }
    if (day < 10) {
        day = `0${day}`
    }
    const dateInputFormatted = `${currentYear}-${currentMonth}-${day}`

    return dateInputFormatted
}